import { useEffect, useState } from 'react';
import { useNavigate, Link } from "react-router-dom";
import getUserInfo from "../../utilities/decodeJwt";

const LandingPage = () => {
    const [user, setUser] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        setUser(getUserInfo());
    }, []);

    if (user) {
        navigate("/game");
        return null;
    }

    return (
        <div className="mv-page flex min-h-[calc(100vh-3.5rem)] flex-col items-center justify-center px-4 py-16">
            <div className="mv-card max-w-xl w-full px-8 py-10 md:px-12 md:py-12">
                <p className="mb-3 text-center text-xs font-semibold uppercase tracking-[0.2em] text-cinema-accent-muted">
                    Welcome
                </p>
                <h1 className="mv-heading text-center text-3xl md:text-4xl">
                    Movie<span className="text-cinema-accent">Duel</span>
                </h1>
                <p className="mt-4 text-center text-base leading-relaxed text-slate-400">
                    Pick which title has the higher IMDb score,
                    prove yourself on the leaderboards and show off your skills.
                </p>
                <div className="mt-10 flex flex-col gap-3 sm:flex-row sm:justify-center">
                    <Link
                        to="/signup"
                        className="mv-btn-primary justify-center py-3 text-center sm:min-w-[11rem]"
                    >
                        Sign up
                    </Link>
                    <Link
                        to="/login"
                        className="mv-btn-secondary justify-center py-3 text-center sm:min-w-[11rem]"
                    >
                        Log in
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default LandingPage;
